<template>
    <div>
    </div>
</template>

<script>
export default {
  name: 'registerUser',
  data() {
    return {};
  },
};
</script>


// WEBPACK FOOTER //
// src/components/views/RegisterUser.vue